import utils from "@/utils/index.js"
// import when from '../../../../../static/js/when.min.js'
/**
 * 校验配置项
 * @static
 * @type {Object}
 */
let config = {
    /**
     * 字符长度，长度匹配的字符的模式 别忘了小数点 中英文同算一个字符
     * @cfg {RegExp} lengthWord
     */
    lengthWord: '[\\w\\s\\.\\u4e00-\\u9fa5]',
    /**
     * 规则错误提示
     * @cfg {String} _errorMessage
     */
    _errorMessage: '不匹配规则: [{{ruleType}}].',
    /**
     * 必填项
     * @cfg required
     * @cfg {Function} required.regular 判断函数
     * @cfg {String} required.msg 提示信息
     * @cfg {Number} required.priority 优先级
     */
    required: {
        regular: function (value) {
            //判断对象情况 [] {}
            if (typeof value === "object") {
                return !utils.isEmptyObject(value);
            }
            //判断 undefined null ""
            else {
                return !utils.isNullOrEmpty(value);
            }
        },
        msg: '必填', // 必填!
        // The [{{name}}] must be required!
        priority: 10000
    },
    /**
     * 校验数字
     * @cfg number
     * @cfg {Function} number.regular 判断函数
     * @cfg {String} number.msg 提示信息
     * @cfg {Number} number.priority 优先级
     */
    number: {
        regular: function (value) {
            // 空格人家认为是必填验证的。。。 空格应当不认为不满足 此验证
            //return utils.isNullOrEmpty(value) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(value)
            //非零开始的数字或小数
            return utils.isNullOrEmpty(value) || utils.isNumber(value);
        },
        msg: "必须是数字格式", // 必须是数字格式
        priority: 1000
    },
    /**
     * 校验整数
     * @cfg integer
     * @cfg {Function} integer.regular 判断函数
     * @cfg {String} integer.msg 提示信息
     * @cfg {Number} integer.priority 优先级
     */
    integer: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^-?(\d+)?$/.test(value);
        },
        msg: "必须是整数", // 必须是整数
        priority: 1000
    },
    /**
     * 校验纯数字
     * @cfg digits
     * @cfg {Function} digits.regular 判断函数
     * @cfg {String} digits.msg 提示信息
     * @cfg {Number} digits.priority 优先级
     */
    digits: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^\d+$/.test(value);
        },
        msg: "必须是纯数字", // 必须是纯数字
        priority: 1000
    },
    datepicker: {
        regular: function (value, ruleOp, modal, name, dom) {
            var format;
            //使用text值做兼容 而不是value值
            if (dom) {
                value = dom.val();
                format = ruleOp.format;
            } else {
                format = ruleOp.dbFormat || 'yyyy-MM-dd hh:mm:ss';
                value && value.length === 10 && (format = 'yyyy-MM-dd'); //兼容处理日期
            }

            ruleOp.msg = ruleOp.msg || "日期格式错误:" + " {{format}}";
            //验证类型： ruleOp.ruleType
            // fixed: 自定义grid的日期列的格式时(如：dateFormat:dd/MM/yyyy)，提示校验不通过 20170608 l00195395（toDate转换时添加传入format）
            return value == undefined || value == "" || ((value.length == format.length) && (utils.date.toDate(value, format) !== undefined));
        }
    },
    /**
     * 校验日期
     * @cfg date
     * @cfg {Function} date.regular 判断函数
     * @cfg {String} date.msg 提示信息
     * @cfg {Number} date.priority 优先级
     */
    date: {
        regular: function (value, ruleOp) {
            // \d\d:\d\d:\d\d$/.test('2014-12-01 00:00:00')
            ruleOp.msg = ruleOp.msg || "日期格式错误:" + " {{format}}";
            //验证类型： ruleOp.ruleType
            return utils.isNullOrEmpty(value) || ((value.length == ruleOp.format.length) && (utils.date.toDate(value) !== undefined)); //, ruleOp.format 12-8
        },
        format: "yyyy-MM-dd", //reqular方法里用于 验证数据格式用
        priority: 1000
    },
    /**
     * 校验时间
     * @cfg time
     * @cfg {Function} time.regular 判断函数
     * @cfg {String} time.msg 提示信息
     * @cfg {Number} time.priority 优先级
     */
    time: { //短时间格式，按需要以后再增加longTime，fullTime
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^((0)[0-9]|1[0-9]|20|21|22|23):([0-5][0-9])$/.test(value);
        },
        msg: "validation.timeErr",
        priority: 1000
    },
    /**
     * 校验含秒的日期时间格式
     * @cfg longDateTime
     * @cfg {Function} longDateTime.regular 判断函数
     * @cfg {String} longDateTime.msg 提示信息
     * @cfg {Number} longDateTime.priority 优先级
     */
    longDateTime: {
        regular: function (value, ruleOp) {
            // \d\d:\d\d:\d\d$/.test('2014-12-01 00:00:00')
            ruleOp.msg = ruleOp.msg || "日期格式错误:" + " {{format}}";
            //验证类型： ruleOp.ruleType
            return utils.isNullOrEmpty(value) || ((value.length == ruleOp.format.length) && (utils.date.toDate(value) !== undefined)); //, ruleOp.format 12-8
        },
        format: "yyyy-MM-dd hh:mm:ss",
        priority: 1000
    },
    /**
     * 校验日期时间格式
     * @cfg dateTime
     * @cfg {Function} dateTime.regular 判断函数
     * @cfg {String} dateTime.msg 提示信息
     * @cfg {Number} dateTime.priority 优先级
     */
    dateTime: {
        regular: function (value, ruleOp) {
            // \d\d:\d\d:\d\d$/.test('2014-12-01 00:00:00')
            ruleOp.msg = ruleOp.msg || "日期格式错误:" + " {{format}}";
            //验证类型： ruleOp.ruleType
            return utils.isNullOrEmpty(value) || ((value.length == ruleOp.format.length) && (utils.date.toDate(value) !== undefined)); //, ruleOp.format 12-8
        },
        format: "yyyy-MM-dd hh:mm",
        priority: 1000
    },
    /**
     * 校验日期格式 yyyy-MM
     * @cfg dateYM
     * @cfg {Function} dateYM.regular 判断函数
     * @cfg {String} dateYM.msg 提示信息
     * @cfg {Number} dateYM.priority 优先级
     */
    dateYM: {
        regular: function (value, ruleOp) {
            // \d\d:\d\d:\d\d$/.test('2014-12-01 00:00:00')
            ruleOp.msg = ruleOp.msg || "日期格式错误:" + " {{format}}";
            //验证类型： ruleOp.ruleType
            return utils.isNullOrEmpty(value) || ((value.length == ruleOp.format.length) && (utils.date.toDate(value) !== undefined)); //, ruleOp.format 12-8
        },
        format: "yyyy-MM",
        priority: 1000
    },
    /**
     * 校验日期格式 yyyy-MM
     * @cfg yearMonth
     * @cfg {Function} yearMonth.regular 判断函数
     * @cfg {String} yearMonth.msg 提示信息
     * @cfg {Number} yearMonth.priority 优先级
     */
    yearMonth: {
        regular: function (value, ruleOp) {
            // \d\d:\d\d:\d\d$/.test('2014-12-01 00:00:00')
            ruleOp.msg = ruleOp.msg || "日期格式错误:" + " {{format}}";
            //验证类型： ruleOp.ruleType
            return utils.isNullOrEmpty(value) || ((value.length == ruleOp.format.length) && (utils.date.toDate(value) !== undefined)); //, ruleOp.format 12-8
        },
        format: "yyyy-MM",
        priority: 1000
    },
    /**
     * 校验百分比
     * 规则只管返回true false 消息会在以后的步骤 buildErrorMessage 中装饰 . msg做数据占位结构，ruleOp做替换占位的数据对象
     * 可用  rate:true 和 rate:{msg:..}两种方式调用
     * @cfg rate
     * @cfg {Function} rate.regular 判断函数
     * @cfg {String} rate.msg 提示信息
     * @cfg {Number} rate.priority 优先级
     */
    rate: {
        regular: function (value, ruleOp) {
            var ret = false;
            var max = (ruleOp && ruleOp.max) ? ruleOp.max * 1 : 100,
                min = (ruleOp && ruleOp.min) ? ruleOp.min * 1 : 0;
            if ((/^\d+(\.\d+)?%$/i.test(value)) && !isNaN(max) && !isNaN(min)) {
                value = parseFloat(value);
                ret = (value <= max && value >= min);
            }
            ruleOp.msg = ruleOp.msg || "validation.rateErr";
            ruleOp.max = max;
            ruleOp.min = min;
            return ret;
        },
        msg: "validation.rateErr",
        priority: 1000
    },
    /**
     * 校验版本格式，可用  rate:true 和 rate:{msg:..}两种方式调用
     * @cfg version
     * @cfg {RegExp} version.regular 判断正则表达式
     * @cfg {String} version.msg 提示信息
     * @cfg {Number} version.priority 优先级
     */
    version: {
        regular: /^\d+\.\d+(\.\d+)*$/,
        msg: "validation.versionErr",
        priority: 1000
    },
    /**
     * 校验Email格式
     * @cfg email
     * @cfg {Function} email.regular 判断正则表达式
     * @cfg {String} email.msg 提示信息
     * @cfg {Number} email.priority 优先级
     */
    email: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^[a-zA-Z0-9_+.-]+\@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,4}$/.test(value);
        },
        msg: "validation.emailErr", // 必须是email格式
        priority: 1000
    },
    /**
     * 校验URL格式
     * @cfg url
     * @cfg {Function} url.regular 判断正则表达式
     * @cfg {String} url.msg 提示信息
     * @cfg {Number} url.priority 优先级
     */
    url: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^([a-zA-Z]{3,}):\/\/([\w-]+\.)+[\w]+(\/[a-zA-Z- ./?%&=]*)?/i.test(value);
        },
        msg: "validation.urlErr", // 必须是url格式
        priority: 1000
    },
    /**
     * 校验数字、字母、下划线、中文
     * @cfg speczh
     * @cfg {Function} speczh.regular 判断正则表达式
     * @cfg {String} speczh.msg 提示信息
     * @cfg {Number} speczh.priority 优先级
     */
    speczh: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^[0-9a-zA-Z_\u4e00-\u9fa5]+$/.test(value);
        },
        msg: "必须是普通字符0-9、a-z、A-Z、下划线、汉字等",
        priority: 1000
    },
    /**
     * 校验数字、字母、下划线、横杠、点号
     * @cfg specialch
     * @cfg {Function} specialch.regular 判断正则表达式
     * @cfg {Number} specialch.priority 优先级
     */
    specialch: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^[0-9a-zA-Z_\-\.]+$/.test(value);
        },
        priority: 1000
    },
    /**
     * 校验数字、字母、下划线、横杠
     * @cfg specialch2
     * @cfg {Function} specialch2.regular 判断正则表达式
     * @cfg {Number} specialch2.priority 优先级
     */
    specialch2: {
        regular: function (value) {
            return utils.isNullOrEmpty(value) || /^[0-9a-zA-Z_\-]+$/.test(value);
        },
        priority: 1000
    },
    /**
     * 文件扩展名校验,各文件扩展名之间使用|符号分割，如png|jpe?g|gif，支持正则表达式
     * @cfg accept
     * @cfg {Function} accept.regular 判断正则表达式
     * @cfg {String} accept.msg 提示信息
     * @cfg {Number} accept.priority 优先级
     */
    accept: {
        regular: function (value, ruleOp) {
            var pattern = (ruleOp && ruleOp.value) ? ruleOp.value.replace(/,/g, '|') : "png|jpe?g|gif";
            var ret = value.match(new RegExp("\\.(" + pattern + ")$")); // \.(jpg) 才能匹配.jpg，不然 .ajpg也会匹配的(因为这时的.被a匹配到而占用了)
            if (ret) {
                ret = true;
            } else {
                ruleOp.result = pattern;
                ret = false;
            }
            return ret;
        },
        msg: "validation.acceptErr",
        priority: 1000
    },
    /**
     * 校验文件大小格式
     * @cfg fileSize
     * @cfg {RegExp} fileSize.regular 判断正则表达式
     * @cfg {String} fileSize.msg 提示信息
     * @cfg {Number} fileSize.priority 优先级
     */
    //文件大小，形如XXX.XXX K的检验
    fileSize: {
        regular: /^\d+(\.\d+)?[KMGTPEZY]?B$/i,
        msg: "validation.fileSizeErr",
        priority: 1000
    },
    /**
     * 校验最大长度
     * @cfg maxLength
     * @cfg {Function} maxLength.regular 判断正则表达式
     * @cfg {String} maxLength.msg 提示信息
     * @cfg {Number} maxLength.priority 优先级
     */
    maxLength: {
        regular: function (value, ruleOp) {
            var maxLen = ruleOp.value,
                len = Number(maxLen);
            ruleOp.length = len;
            //value.replace(/[^\x00-\xff]/g, '__').length
            return utils.getLength(value, ruleOp.lengthRegular) <= len;
        },
        msg: 'validation.maxLengthErr',
        priority: 500
    },
    /**
     * 校验最小长度
     * @cfg minLength
     * @cfg {Function} minLength.regular 判断正则表达式
     * @cfg {String} minLength.msg 提示信息
     * @cfg {Number} minLength.priority 优先级
     */
    minLength: {
        regular: function (value, ruleOp) {
            var minLen = ruleOp.value,
                len = Number(minLen);
            ruleOp.length = len;
            return utils.isNullOrEmpty(value) || utils.getLength(value, ruleOp.lengthRegular) >= len;
        },
        msg: 'validation.minLengthErr',
        priority: 500
    },
    /**
     * 校验长度范围
     * @cfg lenRange
     * @cfg {Function} lenRange.regular 判断正则表达式
     * @cfg {String} lenRange.msg 提示信息
     * @cfg {Number} lenRange.priority 优先级
     */
    lenRange: {
        regular: function (value, ruleOp) {
            try {
                var lens = ruleOp.value,
                    minLen = lens[0],
                    maxLen = lens[1],
                    minResult = utils.getLength(value, ruleOp.lengthRegular) >= minLen,
                    maxResult = utils.getLength(value, ruleOp.lengthRegular) <= maxLen;
                ruleOp.minLen = minLen;
                ruleOp.maxLen = maxLen;
                return minResult && maxResult;
            } catch (e) {
                return false;
            }
        },
        msg: 'validation.lenRange',
        priority: 500
    },
    /**
     * 校验是否等于
     * @cfg equalTo
     * @cfg {Function} equalTo.regular 判断正则表达式
     * @cfg {String} equalTo.msg 提示信息
     * @cfg {Number} equalTo.priority 优先级
     */
    equalTo: {
        regular: function (value, ruleOp) {
            return value === ruleOp.value;
        }
    },
    /**
     * 校验XML格式
     * @cfg XML
     * @cfg {Function} XML.regular 判断正则表达式
     * @cfg {String} XML.msg 提示信息
     * @cfg {Number} XML.priority 优先级
     */
    XML: {
        priority: 1000,
        regular: function (value, ruleOp) {
            if (value == '' || value == null) {
                return true;
            }
            // errorCode 0是xml正确，1是xml错误，2是无法验证
            var xmlDoc, errorMessage, errorCode = 0;
            // code for IE
            if (window.ActiveXObject) {
                xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                xmlDoc.async = "false";
                xmlDoc.loadXML(value);

                if (xmlDoc.parseError.errorCode != 0) {
                    errorMessage = 'validation.xmlErr';
                    errorCode = 1;
                } else {
                    errorMessage = "格式正确";
                }
            }
            // code for Mozilla, Firefox, Opera, chrome, safari,etc.
            else if (document.implementation.createDocument) {
                var parser = new DOMParser();
                try {
                    xmlDoc = parser.parseFromString(value, "text/xml");
                    var error = xmlDoc.getElementsByTagName("parsererror");
                    if (error.length > 0) {
                        if (xmlDoc.documentElement.nodeName == "parsererror") {
                            errorCode = 1;
                            errorMessage = xmlDoc.documentElement.childNodes[0].nodeValue;
                        } else {
                            errorCode = 1;
                            errorMessage = xmlDoc.getElementsByTagName("parsererror")[0].innerHTML;
                        }
                        errorMessage = 'validation.xmlErr';
                    } else {
                        errorMessage = "格式正确";
                    }
                } catch (e) {
                    errorCode = 1;
                    errorMessage = 'validation.xmlErr';
                }
            } else {
                errorCode = 2;
                errorMessage = "浏览器不支持验证，无法验证xml正确性";
            }
            if (!errorCode) {
                return true;
            } else {
                ruleOp.msg = errorMessage;
                ruleOp.errorCode = errorCode;
                return false;
            }
        }
    },
    /**
     * 判断是否大于最小值
     * @cfg min
     * @cfg {Function} min.regular 判断正则表达式
     * @cfg {String} min.msg 提示信息
     */
    min: {
        regular: function (value, ruleOp) {
            return utils.isNullOrEmpty(value) || (value >= ruleOp.value);
        },
        msg: "validation.minErr"
    },
    /**
     * 判断是否小于最大值
     * @cfg max
     * @cfg {Function} max.regular 判断正则表达式
     * @cfg {String} max.msg 提示信息
     */
    max: {
        regular: function (value, ruleOp) {
            return utils.isNullOrEmpty(value) || (value <= ruleOp.value);
        },
        msg: "validation.maxErr"
    },
    /**
     * 校验JSON格式
     * @cfg json
     * @cfg {Function} json.regular 判断正则表达式
     * @cfg {String} json.msg 提示信息
     */
    json: {
        regular: function (value) {
            if (utils.isNullOrEmpty(value)) {
                return true;
            }
            try {
                JSON.parse(value);
            } catch (e) {
                return false;
            }
            return true;
        },
        msg: "validation.jsonErr"
    }

}



/**
 * 检查校验方法
 * @private
 * @param {Object} ruleOp 规则的参数
 * @param {String} value 需要校验的值
 * @param {String} name 需要校验的名称
 * @param {String} modal 需要校验的模式
 * @param {Object} target 需要校验的对象
 * @returns {Promise|Boolean}
 */
function check(ruleOp, value, name, modal, target) {
	var regular = ruleOp.regular,
		type = typeof regular;
	// ajax类型
	var defer = utils.deferred();
	// regular直接是函数
	if (type === "function") {
		utils.when(regular(value, ruleOp, modal, name, target)).done(function (data) {
			defer.resolve(data);
		});
		return defer.promise();
		// 直接正则表达式
	} else if (type === "string") {
		var reg = new RegExp(type);
		if (reg) {
			return regular.test(value);
		}
		// regular下面有test方法
	} else if (regular && regular.test) {
		return regular.test(value);
	}
}
/**
 * 创建错误提示信息
 * @private
 * @param {String} name 需要校验的名称
 * @param {Object} ruleOp 需要校验的参数
 * @param {String} value 需要校验的值
 * @param {String} modal 需要校验的模式
 * @param {Object} target 需要校验的目标
 * @returns {String}
 */
function buildErrorMessage(name, ruleOp, value, modal, target) {
	var msg = ruleOp.msg;
	// 方式类型执行返回
	if (utils.isFunction(msg)) {
		return msg(name, ruleOp, value, modal, target);
	} else {
		msg = msg ? msg: config._errorMessage;
	}
	return msg
}






export default { 
	validRules(rules, value, name, modal, target) {
		var defer = utils.deferred();
		var length = Object.keys(rules).length;
		var i = 0;
		var self = this;
		var CONFIG = config;
		var sortRules = [];
		var prioritys = [];
		for (const key in rules) {
			if (rules.hasOwnProperty(key)) {
				let ruleParam=rules[key],ruleType=key
				var ruleOp;
				if (ruleParam === true) {
					ruleOp = CONFIG[ruleType];
					//默认校验有参数 包括数组和具体的值 等非对象
				} else if (typeof ruleParam !== "object" || Array.isArray(ruleParam)) { // || util.isNumeric(ruleParam)
					//不是对象类型的都进（字符串、数字。。。）。 如  maxLength: 6 转成  maxLength: {value:6}的格式
					ruleOp = Object.assign({}, CONFIG[ruleType], {
						value: ruleParam
					});
					ruleOp.ruleType = ruleType;
				} else {
					//自定义校验
					ruleOp = Object.assign({}, CONFIG[ruleType], ruleParam);
					ruleOp.ruleType = ruleType;
				}
				sortRules.push(ruleOp);
				prioritys.push(ruleOp.priority || 0);
			}
		}
	
		function checkRule() {
			if (prioritys.length) {
				var max = Math.max.apply(null, prioritys);
				var index = prioritys.indexOf(max);
				utils.when(check(sortRules[index], value, name, modal, target)).done(function (result) {
					//兼容规则判断，返回true "true" 1 为通过
					if (result === true || result === "true" || result === 1) {
						prioritys.splice(index, 1);
						sortRules.splice(index, 1);
						i++;
						if (i === length) {
							defer.resolve(true);
						} else {
							checkRule();
						}
					} else {
						//返回false 0 "false" 为不通过并计算错误提示
						if (result === false || result === 0 || result === "false") {
							result = buildErrorMessage(name, sortRules[index], value, modal, target);
						}
						defer.resolve(result, name, result);
					}
				});
			} else {
				defer.resolve(true);
			}
		}
	
		checkRule();
		return defer.promise();
	},
	/**
	* 添加校验规则。
	* @param {String} ruleName 规则名称
	* @param {Object} ruleOp 规则对象
	*/
	addRule(ruleName, ruleOp) {
		this.config[ruleName] = ruleOp;
	},
	/**
	 * 删除校验规则。
	 * @param {String} ruleName 规则名称
	 */
	removeRule(ruleName) {
		delete this.config[ruleName];
	},
	/**
	 * 获取校验规则。
	 * @param {String} ruleName 规则名称
	 * @returns {Object}
	 */
	getRule(ruleName) {
		return this.config[ruleName];
	},
	/**
	 * valid 校验方法入口(已废弃)。
	 * @param {String} name 需要校验的名称
	 * @param {String} value 需要校验的值
	 * @param {String} modal 需要校验的模式
	 * @param {Object} target 需要校验的目标
	 * @returns {Promise|Boolean}
	 */
	valid(name, value, modal, target) {
		var self = this;
		var checkCalls = this.validList[name];
		if (checkCalls && (!utils.isEmptyObject(checkCalls))) {
			// 验证单个field方法
			var defer = new Promise(),
				validResult = true,
				errorMsg;
				utils.when(self.validRules(checkCalls, value, name, modal, target)).always(function (result, name) {
				if (result !== true) {
					validResult = false;
					errorMsg = result;
				}
				utils.when(self.$fire("validItem", [validResult, name, errorMsg, target])).always(function () {
					// 返回：结果+错误信息+名称
					defer.resolve(validResult, errorMsg, name);
				});
			});
			return defer.promise();
		}
		return true;
	}
};



// WEBPACK FOOTER //
// ./src/components/common/table/validated/validator.js